import { useMemo, useRef, useCallback } from 'react';
export default function useOnItemHeightDidChange(_ref) {
  var getItemKey = _ref.getItemKey,
      onItemKeysReset = _ref.onItemKeysReset,
      virtualScroller = _ref.virtualScroller;
  // Only create the initial cache once.
  var initialCache = useMemo(function () {
    return createCache();
  }, []); // A cache of `onItemHeightDidChange()` functions.

  var cache = useRef(initialCache); // Adds an "on item keys reset" listener that clears the cache when item keys are reset.

  useMemo(function () {
    onItemKeysReset(function () {
      cache.current = createCache();
    });
  }, []); // Caches per-item `onItemHeightDidChange` functions' "references"
  // so that item components don't get re-rendered needlessly.

  var getOnItemHeightDidChange = useCallback(function (item) {
    var itemKey = getItemKey(item);

    if (!cache.current[itemKey]) {
      cache.current[itemKey] = function () {
        virtualScroller.onItemHeightDidChange(item);
      };
    }

    return cache.current[itemKey];
  }, [virtualScroller, getItemKey, cache]);
  return getOnItemHeightDidChange;
}

function createCache() {
  // It could also use a `new Map()` here and then use `item` as a key.
  // Although, sometimes an `item` "reference" might change while it still being
  // the same item, i.e. having the same `getItemId(item)` value.
  return {};
}
//# sourceMappingURL=useOnItemHeightDidChange.js.map